// extracted by mini-css-extract-plugin
module.exports = {"message_wrapper":"Message_message_wrapper__2fEOL","avatar":"Message_avatar__33tb-","message":"Message_message__1uiTk"};